var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRequest = function SvgRequest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.71 5.026v6.732l.072.002c1.38.03 2.994.066 4.421-.263.885-.204 1.577-.528 2.041-.992.438-.437.756-1.078.756-2.115 0-1.097-.274-1.755-.632-2.178-.366-.432-.921-.738-1.702-.934-.786-.198-1.723-.265-2.766-.276a56 56 0 0 0-1.739.015zm0 8.735c1.377.033 3.286.067 4.943-.315 1.08-.25 2.174-.697 3.004-1.525C18.515 11.065 19 9.892 19 8.39q0-2.165-1.105-3.47c-.728-.86-1.718-1.325-2.741-1.582-1.018-.256-2.144-.325-3.232-.336a68 68 0 0 0-1.871.017c-.476.009-.937.017-1.341.017h-1v8.708H6a1 1 0 0 0 0 2h1.71v1.265H6a1 1 0 1 0 0 2h1.71V20a1 1 0 1 0 2 0v-2.991h5.58a1 1 0 0 0 0-2H9.71z",
    clipRule: "evenodd"
  })));
};
export default SvgRequest;